import { productCarouselProductCondensedStyles } from "@insite/content-library/Components/ProductCarouselProductCondensed";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import { css } from "styled-components";

productCarouselProductCondensedStyles.container = {
    gap: 4,
    css: css`
        -webkit-box-flex: 1;
        flex-grow: 1;
        width: 100%;
        padding: 2px;
        border: 1px solid #cccccc;
    `,
};
productCarouselProductCondensedStyles.imageGridItem = {
    width: 3,
    css: css`
        overflow: visible;
        display: flex;
        flex-direction: row;
        padding: 2px;
        align-items: flex-start;
        overflow-wrap: break-word;
        word-break: break-word;
        flex-basis: 100%;
        max-width: 100%;
        > a {
            div[class^="LazyImageStyle"] {
                height: 100px;
                -webkit-box-align: center;
                align-items: center;
                -webkit-box-pack: center;
                justify-content: center;
                background: rgb(255, 255, 255);
            }
        }
    `,
};

productCarouselProductCondensedStyles.productDetailsGridItem = {
    width: 7,
    css: css`
        flex-direction: column;
        display: none !important;
    `,
};
productCarouselProductCondensedStyles.condensedActionsTemplateGridItem = {
    width: 1,
    css: css`
        overflow: visible;
        display: flex;
        flex-direction: row;
        padding: 2px;
        align-items: flex-start;
        overflow-wrap: break-word;
        word-break: break-word;
        flex-basis: 8.33333%;
        max-width: 8.33333%;
        position: absolute;
        top: -5px;
        right: 50px;
        background: transparent;
        border: none;
        > button {
            background: transparent;
            border: none;
        }
    `,
};
